import { render, staticRenderFns } from "./settings_history_diff_cell.vue?vue&type=template&id=38ed1c2e&scoped=true&"
import script from "./settings_history_diff_cell.vue?vue&type=script&lang=js&"
export * from "./settings_history_diff_cell.vue?vue&type=script&lang=js&"
import style0 from "./settings_history_diff_cell.vue?vue&type=style&index=0&id=38ed1c2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ed1c2e",
  null
  
)

export default component.exports